/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-09-12 14:47:36
 */
import React, { useState, useEffect} from "react";
import { Modal, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { EyeInvisibleOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import DeleteModal from '../delete-modal';
import ApplyModal from "../../my-invoice/components/apply-modal";
import ViewModal from "../../my-invoice/components/view-modal";
import ReceiptModal from "../../my-invoice/components/receipt-modal";
import ProcessModal from '../../payment/components/process-modal';
import { payList,orderStatusArr } from '../../myOrder/config';
import { deleteOrderList, confirmReceipt } from '@/api/personal-center';
import OrderCancel from '../../../personal-center/components/order-cancel';
import './index.scss';
import { message,Tooltip } from "antd";
import { getBill } from '@/api/my-invoice';
import {getBuyWay} from '@/utils'
import copyBtn from '../../assets/copy_btn.svg';
import eyeOpenBtn from '../../assets/eye_open_btn.svg';
import { getActivation } from '@/api/personal-center';
import CodeModal from '../code-modal';
import FreeModal from '../free-modal';
interface IProps {
  orderData: any,
  setIsRefresh?:any
}
const OrderTableMain: React.FC<IProps> = (props) => {
  const { orderData,setIsRefresh } = props;
  const navigate = useNavigate();
  const [orderDeleteModal, setOrderDeleteModal] = useState(false);
  const [orderInfo, setOrderInfo] = useState([]);
  const [orderId, setOrderId] = useState(''); // 订单id
  const [cancelFlag, setCancelFlag] = useState(false); // 取消订单
  const [sureFlag, setSureFlag] = useState(false); // 确认收货
  const [showProcessModal, setShowProcessModal] = useState(false); // 对公支付弹窗
  const [currentOrder, setCurrentOrder] = useState<any>({}); // 当前选中订单
  const [showApplyModal, setShowApplyModal] = useState(false); // 申请开票
  const [showViewModal, setShowViewModal] = useState(false); // 查看发票进度
  const [showReceiptModal, setShowReceiptModal] = useState(false); // 查看发票
  const [invoiceObject, setInvoiceObject] = useState({
    billId: '',
    invoiceId: ''
  });
  const [isChange,setIsChange] = useState<number>(1);// 修改申请，掉接口不同，做不同的标记1:第一次，2：修改
  const [modalInfo, setModalInfo] = useState({ info: {}, visible: false });
  const [activationCodes, setActivationCodes] = useState<Record<string, {code: string, visible: boolean}>>({});
  // const [showCode, setShowCode] = useState(false);
  // const [code, setCode] = useState('');
  const [showFreeModal, setShowFreeModal] = useState({ info: {}, visible: false });

  useEffect(() => {
    orderData.map((ele:any) => {
      if(ele.payStatus === 3) {
        ele.orderStatus = '付款审核'
      }else {
        if(ele.status === 1 || ele.status === 2) {
          ele.orderStatus = '待收货'
        }else {
          ele.orderStatus = (orderStatusArr.find((oEle:any) => oEle.value === ele.status))?.label??'-'
        }
      }
      return ele;
    });
    setOrderInfo(orderData);
  },[orderData])
  // 删除订单弹窗
  const orderDeleteDialog = (id:string) => {
    setOrderId(id);
    setOrderDeleteModal(true);
    setIsRefresh(false);
  }

  // 删除订单
  const orderDeleteFunc = () => {
    if(orderId !== '') {
      deleteOrderList(orderId).then((dRes:any) => {
        if(dRes.success) {
          message.success('删除成功！');
          setOrderDeleteModal(false);
          setIsRefresh(true);
        }else {
          message.error(dRes.message);
        }
      }) 
    }
  }
  // 取消订单
  const cancelOrderDialog = (id:string) => {
    setOrderId(id);
    setCancelFlag(true);
    setIsRefresh(false);
  }
  // 立即支付
  const nowPayFunc = (id:string) => {
    navigate(`/user/payment?orderId=${id}`);
  }
  // 确认收货弹窗
  const confirmDialog = (id:string) => {
    setOrderId(id);
    setSureFlag(true);
    setIsRefresh(false);
  }
  // 确认收货
  const confirmReceiptFunc = () => {
    confirmReceipt(orderId).then((cRes:any) => {
      if(cRes.success) {
        setIsRefresh(true);
      }else {
        message.error(cRes.message);
      }
    })
    setSureFlag(false);
  }
  // 立即支付弹窗
  const payNowDialog = (oData:any) => {
    setCurrentOrder(oData);
    setShowProcessModal(true);
  }
  // 申请售后
  const applyServiceFunc = (id:number,status:number) => {
    if(status === 1) {
      message.warning('已全部退款，请勿重复操作，如有疑问请联系客服');
    }else {
      navigate(`/user/as/${id}`);
    }
  }
  // 发票点击
  const invoiceOperate = (flag:number,info:any) => {
    switch(flag) {
      case 1:
        setShowApplyModal(true);
        setIsRefresh(false);
        break
      case 2:
        setShowViewModal(true);
        break
      case 3:
        // setShowReceiptModal(true);
        handleViewReceipt(info.id);
        break
    }
    setOrderId(info.id);
    setInvoiceObject({
      billId: info.billId,
      invoiceId: info.billItemId
    })
  }
   // 查看发票
   const handleViewReceipt = (id: number) => {
    // setOrderId(id);
    // setShowReceiptModal(true);
    getBill(id).then((res: any) => {
      if (res.success) {
        // setReceiptUrl(res.obj?.showUrl);
       window.open(res.obj?.showUrl, '_blank');
        
      } else {
        message.error(res.message);
      }
    })
  
  }

  const getActiveCode = async (params: any, orderId: string) => {
    const res: any = await getActivation({ ...params, orderId });
    if (res.success) {
      setActivationCodes(prev => ({
        ...prev,
        [orderId]: {
          code: res.obj.code,
          visible: true
        }
      }));
      setModalInfo({ info: {}, visible: false });
    } else {
      message.error(res?.message ?? '查看激活码失败');
    }
  };

  const copyCode = (orderId: string) => {
    const codeToCopy = activationCodes[orderId]?.code || '';
    if (copy(codeToCopy, { format: 'text/plain' })) {
      message.destroy();
      message.success('复制成功');
    }
  };

  const downSDK = (info:any) => {
    const proInfo = info?.productList?.[0] ?? {}; //产品信息
    const modelsInfo = proInfo?.models?.[0] ?? {};
    const subscribe = modelsInfo.subscribe?.[0] ?? {};
    window.location.href = info?.activation?.packageAddr;
    // if (subscribe.unit !== '0') {
    //   window.location.href = info?.activation?.chargePackage;
    //   return;
    // }
    // setShowFreeModal({info:info,visible:true});
  };

  const renderOrderCode = (data: any) => {
    const proInfo = data?.productList?.[0] ?? {}; //产品信息
    const modelsInfo = proInfo?.models?.[0] ?? {};
    const subscribe = modelsInfo.subscribe?.[0] ?? {};
    const orderId = data.id;
    const orderActivation = activationCodes[orderId];

    const downCon = (
      <div className='content-item'>
        <span>
          <a className='sdk' onClick={() => downSDK(data)}>
            下载SDK
          </a>
          <a target='_blank' href={data?.activation?.docUrl} className='guide'>
          开发手册
          </a>
        </span>
      </div>
    );

    if (Object.keys(data?.activation ?? {}).length > 0 && subscribe.unit !== '0') {
      return (
        <>
          {downCon}
          <div className='content-item'>
            <label>激活码：</label>
            <span className="item-container">
              {orderActivation?.visible ? (
                <>
                  <Tooltip placement='topLeft' title={orderActivation.code}>
                    <span className='code-con'>{orderActivation.code}</span>
                  </Tooltip>
                  <img
                    className='copy-btn'
                    onClick={() => copyCode(orderId)}
                    src={copyBtn}
                    alt=''
                  />
                  <EyeInvisibleOutlined
                    onClick={() => setActivationCodes(prev => ({
                      ...prev,
                      [orderId]: {
                        ...prev[orderId],
                        visible: false
                      }
                    }))}
                    className='eye-btn'
                  />
                </>
              ) : (
                <>
                  **************
                  <img 
                    onClick={() => setModalInfo({ info: data, visible: true })}
                    className='eye-open-img' 
                    src={eyeOpenBtn} 
                    alt="" 
                  />
                </>
              )}
            </span>
          </div>
        </>
      );
    }
    
    return <>{Object.keys(data?.activation ?? {}).length > 0 ? <div className="down-con">{downCon}</div> : null}</>;
  };

  return (
    <>
      <div className="order-table-main">
        {
          orderInfo.map((oData:any) => (
            <div className="order-detail" key={oData.id}>
              <div className="detail-title"><p>{oData.createTime}  订单号：{oData.orderNo}</p>{renderOrderCode(oData)}</div>
              <div className="order-table">
                <div className="order-product">
                  {
                    oData.productList.map((pData:any)=> (
                      <div className="order-product-info" key={pData.id}>
                        <div style={{width: 310}} className="style-inset inset-name" title={pData.productName}>
                          <img src={pData.pmsFiles[0]?.url} alt='' onClick={()=>window.open(`/detail?productSn=${pData.productSn}`)} />
                          <div className="order-info-detail">
                            <span onClick={()=>window.open(`/detail?productSn=${pData.productSn}`)}>{pData.productName}</span>
                            {
                              pData.models.length > 0 &&
                              <span className="order-modal">
                              {(pData.models.find((ele:any)=>ele?.type===1))?.models} {pData.models.find((ele:any)=>ele?.feeType==='2')&&getBuyWay((pData.models.find((ele:any)=>ele?.type===1))?.subscribe?.[0]?.unit)}
                              </span>
                            }
                          </div>
                        </div>
                        <div style={{width: 111}} className="style-inset">¥{pData.productPrice}</div>
                        <div style={{width: 71}} className="style-inset">{pData.productQuantity}</div>
                      </div>
                    ))
                  }
                </div>
                
                <div className="order-operate" style={{height: 120*oData.productList.length}}>
                  <div style={{width: 111}} className="style-inset light-color">¥{oData.payAmount}</div>
                  <div style={{width: 100}} className="style-inset">{(payList.find((ele:any) => ele.value === oData.payType && oData.payType !== 0))?.label??'-'}</div>
                  <div style={{width: 111}} className="style-inset status-detail"><span className={`${(oData.status === 3 || oData.status === 4) && 'gray'}`}>{oData.orderStatus}</span><span onClick={()=>window.open(`/user/order/detail/${oData.id}`)}>订单详情</span></div>
                  <div style={{width: 100}} className="style-inset order-btn">
                    {
                      (oData.status === 0 && oData.payType !== 4) &&
                      <>
                        <span style={{color: '#FF5733'}} onClick={()=>nowPayFunc(oData.id)}>立即支付</span>
                        <span onClick={()=>cancelOrderDialog(oData.id)}>取消订单</span>
                      </>
                    }
                    {
                      oData.status === 4 &&
                      <span onClick={()=>orderDeleteDialog(oData.id)}>删除订单</span>
                    }
                    {
                      (oData.payType === 4 && (oData.payStatus === 3 || oData.payStatus === 4)) &&
                      <>
                        <span style={{color: '#FF5733'}} onClick={()=> payNowDialog(oData)}>立即支付</span>
                        <span onClick={()=>cancelOrderDialog(oData.id)}>取消订单</span>
                      </>
                    }
                    {
                      (oData.status === 3 || oData.status === 2 || oData.status === 1) &&
                      <>
                        {
                          oData.status === 2 && 
                          <span style={{color: '#3EB86F'}}  onClick={()=> confirmDialog(oData.id)}>确认收货</span>
                        }
                        <span onClick={()=>applyServiceFunc(oData.id,oData.applyStatus)}>申请售后</span>
                        {
                          oData.billStatus === 0 &&
                          <span>-</span>
                        }
                        {
                          (oData.billStatus === 1 || oData.billStatus === 4) &&
                          <span onClick={()=>{invoiceOperate(1,oData)}}>申请开票</span>
                        }
                        {
                          oData.billStatus === 2 &&
                          <span onClick={()=>{invoiceOperate(2,oData)}}>查看发票</span>
                        }  
                        {
                          oData.billStatus === 3 &&
                          <span onClick={()=>{invoiceOperate(3,oData)}}>查看发票</span> 
                        }  
                      </>
                    }
                  </div>
                </div>
              </div>
            </div>
          ))
        }
       
      </div>
      <DeleteModal
        showDeleteModal={orderDeleteModal}
        setShowDeleteModal={setOrderDeleteModal}
        handleDelete={orderDeleteFunc}
        title='删除提醒'
        content='删除后不可恢复，请确认是否删除？'
        okText='是'
        cancelText='否'
      />
      <Modal
        title="确认收货"
        open={sureFlag}
        onCancel={()=>setSureFlag(false)}
        className="confirm-dialog-main"
        footer={false}
        width={450}
      >
        <p>请您确认是否收到货物？</p>
        <div className="dialog-bottom">
          <Button className="submit-info" onClick={()=>confirmReceiptFunc()}>是</Button>
          <Button onClick={()=>setSureFlag(false)}>否</Button>
        </div>
      </Modal>
      <OrderCancel 
        cancelFlag={cancelFlag} 
        setCancelFlag={setCancelFlag}
        orderId={orderId}
        setIsRefresh={setIsRefresh}
        cancelType={0}
      />
      <ProcessModal
        setShowProcessModal={setShowProcessModal}
        showProcessModal={showProcessModal}
        orderData={currentOrder || {} as any}
        type={currentOrder?.payStatus===4?'order':'close'}
      />
      <ApplyModal
        showApplyModal={showApplyModal}
        setShowApplyModal={setShowApplyModal}
        orderId={orderId}
        id={invoiceObject.invoiceId}
        billId={invoiceObject.billId}
        isChange={ isChange}
        setIsRefresh={setIsRefresh}
      />
      <ViewModal
        showViewModal={showViewModal}
        setShowViewModal={setShowViewModal}
        setShowApplyModal={setShowApplyModal}
        orderId={orderId}
        id={invoiceObject.invoiceId}
        setIsChange={setIsChange
        }
        />
      <ReceiptModal
        showReceiptModal={showReceiptModal}
        setShowReceiptModal={setShowReceiptModal}
        orderId={ orderId}
      />
      <CodeModal
        info={modalInfo.info}
        visible={modalInfo.visible}
        setModalInfo={setModalInfo}
        getActiveCode={(codeInfo)=>getActiveCode(codeInfo,(modalInfo.info as any)?.id ?? '')}
      />
      <FreeModal
        freeVisible={showFreeModal.visible}
        setFreeVisible={(visible) => setShowFreeModal({...showFreeModal,visible})}
        sdkLink={(showFreeModal.info as any)?.activation?.freePackage}
      />
    </>   
  )
}

export default OrderTableMain;